export default "__VITE_ASSET__BYa_cnmu__"